// Configuration centralisée de l'application
export const APP_CONFIG = {
  // Configuration de l'API Backend Django
  API: {
    // Toujours privilégier des URLs relatives (Nginx/CRA proxy gèrent /api),
    // pour éviter tout mixed-content en HTTPS.
    baseUrl: process.env.REACT_APP_API_URL || '/api',
    baseUrlWithoutApi: process.env.REACT_APP_API_BASE_URL || '',
    timeout: 10000,
    retryAttempts: 3
  },

  // Configuration HelloAsso
  HELLOASSO: {
    organizationSlug: 'pass-reunion',
    baseUrl: 'https://www.helloasso.com',
    sandbox: process.env.NODE_ENV === 'development'
  },

  // Configuration de l'application
  APP: {
    name: 'Pass Réunion',
    version: '1.0.0',
    description: 'Billetterie événementielle pour La Réunion'
  },

  // Configuration des routes
  ROUTES: {
    home: '/',
    events: '/events',
    cart: '/cart',
    checkout: '/checkout',
    profile: '/profile',
    login: '/login',
    register: '/register'
  }
};

// Fonction utilitaire pour obtenir la configuration
export const getConfig = (key) => {
  const keys = key.split('.');
  let value = APP_CONFIG;
  
  for (const k of keys) {
    if (value && typeof value === 'object' && k in value) {
      value = value[k];
    } else {
      return undefined;
    }
  }
  
  return value;
};

// Fonction utilitaire pour obtenir l'URL de base de l'API (sans /api)
export const getApiBaseUrl = () => {
  const url = getConfig('API.baseUrlWithoutApi');
  // Si vide, on reste sur l'origin courant (http en local, https en prod)
  return url || window.location.origin;
};

// Fonction utilitaire pour obtenir l'URL complète de l'API (avec /api)
export const getApiUrl = () => {
  const url = getConfig('API.baseUrl');
  // Si vide, fallback relatif
  return url || '/api';
};
